import React from "react";

type ButtonProps = {
  title: string;
  onSubmitHandler?: () => void;
  loading?: boolean;
  icon?: React.ReactNode;
  className?: string;
  disabled?: boolean;
  type?: string;
};

const Button: React.FC<ButtonProps> = ({
  title,
  onSubmitHandler,
  loading,
  className,
  disabled,
  type,
}) => {
  return (
    <button
      onClick={onSubmitHandler}
      disabled={loading || disabled}
      className={`${type} flex items-center justify-center md:text-[16px] text-[14px] font-abel py-3 px-4 rounded-6 hover:bg-[#CDD8FE] hover:text-[#243677] hover:border-[#0B60D6] md:w-[176px] w-[127px] h-[40px] md:h-[55px] border-[#0B60D6] border font-[400] cursor-pointer ${className} ${
        loading ? "opacity-50" : ""
      }`}
    >
      {loading ? "Loading..." : title}
      {/* {title} */}
      {/* {loading && (
        <small className="text-[#ffffff] text-[16px] ml-1"> Loading...</small>
        <div className="border-t-transparent border-solid animate-spin rounded-full border-[white] border-4 h-4 w-4 ml-2"></div>
      )} */}
    </button>
  );
};

export default Button;
